export default "__VITE_ASSET__zuXnar73__";